<template>
  <div>
    <b-card :title="$t('reception.patient-card-dates')">
      <div>
        <div>
          <h5 class="my-2">
            <b>{{ $t("common.name") }}:</b>
            <p class="mx-2 d-inline d-inline">
              {{ patientData.name }}
            </p>
          </h5>
          <h5 class="my-2">
            <b>{{ $t("reception.birth-date") }}:</b>
            <p class="mx-2 d-inline d-inline">
              {{ patientData.birth_date }}
            </p>
          </h5>
          <h5 class="my-2">
            <b>{{ $t("reception.gender") }}:</b>
            <p class="mx-2 d-inline">{{ patientData.gender }}</p>
          </h5>
          <h5 class="my-2">
            <b>{{ $t("reception.phone") }}:</b>
            <p class="mx-2 d-inline" :style="{ direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">{{ patientData.phone }}</p>
          </h5>
        </div>
        <b-row class="mt-4">
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("common.date") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="Name">
              <datepicker
                v-model="dateFilter"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                :disabled-dates="{
                  to: new Date(new Date().setDate(new Date().getDate() - 1)),
                }"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getPatientHistoryDates()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.dates") }}</h2>
          <!-- <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t('common.add') }} {{ $t('common.date') }}
          </b-button> -->
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                class="button-preview"
                pill
                @click="
                  $router.push({
                    name: 'patient-card-timeline',
                    params: { id: $route.params.id, date: data.item.date },
                  })
                "
                variant="outline-secondary"
              >
                {{ $t("common.preview") }}
              </b-button>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientHistoryDates()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      patientData: {},
      dateFilter: "",
      data: [],
      tableColumns: [
        { key: "date", sortable: true, label: this.$t("common.date") },
        {
          key: "patient_cards_count",
          label: this.$t("reception.card-count"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getPatientHistoryDates();
  },
  methods: {
    formatDate(cardDate) {
      // Create a new Date object from the selected date
      const date = new Date(cardDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    async getPatientHistoryDates() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient/${this.$route.params.id}/cards-grouped-by-date?page=${this.page}&take=${this.take}`;
      if (this.dateFilter) {
        url += `&filter[date]=${this.formatDate(this.dateFilter)}`;
      }
      await this.getList(url);
      this.getPatient();

      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    async getPatient() {
      this.loading = true;
      let url = `/patient/${this.$route.params.id}`;
      await this.getList(url);
      this.patientData = this.all_data;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
